import React from "react";
import styles from "./../../sass/landing/problem-solution.module.scss";
import classNames from "classnames";

const ProblemSolution = (props) => {
  return (
    <>
      <div className={classNames(styles["process"], "container")}>
        <div className="row h-100">
          <div className="col-12 text-center">
            <h3>
              How It Works
            </h3>
          </div>
          <div className="col-md-6 col-12 mb-4 h-100">
            <div className={classNames(styles["tile"], "p-4")}>
              <h4>1</h4>
              <p>
                An Emission Reduction project including reforestation, renewable energy and sustainable farming earns a digital certificate as proof that 1 ton of CO2 (carbon dioxide) was removed from the atmosphere.
              </p>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-md-6 col-12 mb-4">
            <div className={classNames(styles["tile"], "p-4")}>
              <h4>2</h4>
              <p>
                These credits can then be submitted to the BCX for listing.
              </p>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-md-6 col-12 mb-4 mb-md-0">
            <div className={classNames(styles["tile"], "p-4")}>
              <h4>3</h4>
              <p>
                Credits are audited by our international compliance team following strict global protocols before being approved for listing on the BCX.
              </p>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className={classNames(styles["tile"], "p-4")}>
              <h4>4</h4>
              <p>
                Companies or individuals looking to offset their emissions or to impact invest can then purchase these credits. They do not expire (until they are retired by someone or a company that wants to compensate for their GHG emission).
              </p>
              <div className={classNames(styles["divider"])}></div>
            </div>
          </div>
          <div className="col-12 text-center">
            <p className={classNames(styles["caption"])}>Like a fine wine you can "consume" your carbon credit or allow it to grow in value for future trading.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProblemSolution;
